import utilMixin from '@/mixins/util.mixin';

export class Profissional {
  constructor({
    id = null,
    nome = null,
    foto = null,
    cpf = null,
    email = null,
    telefone = null,
    perfil = null,
    escolaridade = null,
    funcao = null,
    municipio = null,
    lotacao = null,
    endereco = Endereco.Build(),
    possuiNomeSocial = null,
    nomeSocial = null,
    possuiOutroLocalDeLotacao = null,
    lotacaoDois = null,
    municipioLotacaoDois = null,
  }) {
    this.id = id;
    this.nome = nome;
    this.foto = foto;
    this.cpf = cpf;
    this.email = email;
    this.telefone = telefone;
    this.perfil = perfil;
    this.escolaridade = escolaridade;
    this.funcao = funcao;
    this.municipio = municipio;
    this.lotacao = lotacao;
    this.endereco = endereco;
    this.possuiNomeSocial = possuiNomeSocial;
    this.nomeSocial = nomeSocial;
    this.lotacaoDois = lotacaoDois;
    this.possuiOutroLocalDeLotacao = possuiOutroLocalDeLotacao;
    this.municipioLotacaoDois = municipioLotacaoDois;
  }
  static Build() {
    return new Profissional({
      id: null,
      nome: null,
      foto: null,
      cpf: null,
      email: null,
      telefone: null,
      perfil: null,
      escolaridade: null,
      funcao: null,
      municipio: null,
      lotacao: null,
      endereco: Endereco.Build(),
      possuiNomeSocial: false,
      nomeSocial: null,
      lotacaoDois: null,
      possuiOutroLocalDeLotacao: false,
      municipioLotacaoDois: null,
    });
  }
  formatParaVisualizar(data) {
    const foto = data.arquivo;
    this.foto = foto ? utilMixin.methods.$getFileFromBase64(foto.conteudo, foto.nome, foto.tipoDoConteudo, foto.extensao) : null;
    this.endereco = new Endereco(data);
    this.municipio = data.municipioLotacao?.nome || null;
    this.lotacao = data.lotacao?.nome || null;
    this.lotacaoDois = data.lotacaoDois?.nome || null;
    this.municipioLotacaoDois = data.municipioLotacaoDois?.nome || null;
    return this;
  }
  formatParaEditar(data) {
    const foto = data.arquivo;
    this.foto = foto ? utilMixin.methods.$getFileFromBase64(foto.conteudo, foto.nome, foto.tipoDoConteudo, foto.extensao) : null;
    this.endereco = new Endereco(data);
    this.municipio = data.municipioLotacao?.nome || null;
    this.perfil = data.perfil?.id || null;
    this.lotacao = data.lotacao?.id || null;
    this.lotacaoDois = data.lotacaoDois?.id || null;
    this.funcao = data.funcao?.id || null;
    this.municipioLotacaoDois = data.municipioLotacaoDois?.nome || null;
    return this;
  }
  formatParaEnviar() {
    return {
      id: this.id,
      nome: this.nome,
      foto: this.foto,
      cpf: this.cpf.replace(/\D/g, ''),
      telefone: this.telefone.replace(/\D/g, ''),
      email: this.email,
      escolaridade: this.escolaridade,
      funcaoId: this.funcao,
      lotacaoId: this.lotacao.id ? this.lotacao.id : this.lotacao,
      perfilId: this.perfil,
      bairro: this.endereco.bairro,
      cep: this.endereco.cep.replace(/\D/g, ''),
      complemento: this.endereco.complemento,
      logradouro: this.endereco.logradouro,
      municipio: this.endereco.municipio,
      numero: this.endereco.numero,
      uf: this.endereco.uf,
      possuiNomeSocial: this.possuiNomeSocial,
      nomeSocial: this.nomeSocial,
      possuiOutroLocalDeLotacao: this.possuiOutroLocalDeLotacao,
      municipioLotacaoDois: this.endereco.municipio,
      lotacaoDoisId: this.lotacaoDois?.id ? this.lotacaoDois.id : this.lotacaoDois,
    }
  }
}

export class Endereco {
  constructor({
    cep = null,
    logradouro = null,
    bairro = null,
    uf = null,
    numero = null,
    municipio = null,
    municipioEndereco = null,
    complemento = null,
  }) {
    this.cep = cep;
    this.logradouro = logradouro;
    this.bairro = bairro;
    this.uf = uf;
    this.numero = numero;
    this.municipio = municipio || municipioEndereco?.nome;
    this.complemento = complemento;
  }
  static Build() {
    return new Endereco({
      cep: null,
      logradouro: null,
      bairro: null,
      uf: null,
      numero: null,
      municipio: null,
      complemento: null,
    });
  }
}

